import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Responsive } from 'react-grid-layout';
import { omit } from 'lodash';
import { GRID_CONTAINER_PADDING, GRID_MARGIN, GRID_ROW_HEIGHT, LG_BREAKPOINT } from 'app/stores/boards/constants';
import dashboardWidthProvider from 'app/views/core/dashboards/DashboardWidthProvider';
import BoardPanelView from 'app/views/boards/BoardPanelView';

const gridLayoutDefaults = {
  breakpoints: { lg: LG_BREAKPOINT, sm: 0 },
  cols: { lg: 12, sm: 1 },
  containerPadding: [GRID_CONTAINER_PADDING, GRID_CONTAINER_PADDING],
  margin: [GRID_MARGIN, GRID_MARGIN],
  rowHeight: GRID_ROW_HEIGHT
};

@inject('$boards')
@dashboardWidthProvider
@observer
class BoardGridLayout extends Component {
  static defaultProps = {
    panels: [],
    layout: {},
    onAddPanel: () => {},
    onLayoutChange: () => {},
    onRemovePanel: () => {},
    onResize: undefined,
    itemDraggableHandle: 'drag-header'
  };

  handleLayoutChange = (currentBreakpointLayout, allLayouts) => {
    const { onLayoutChange } = this.props;

    // Need to strip out `moved` and `static`. Using `omit`, because static is a reserved word
    const { lg, sm } = allLayouts;
    const layout = { lg: [], sm: [] };

    layout.lg = lg.map((layoutItem) => omit(layoutItem, ['moved', 'static']));
    layout.sm = sm.map((layoutItem) => omit(layoutItem, ['moved', 'static']));

    onLayoutChange(layout);
  };

  renderPanels() {
    const {
      board,
      panels,
      itemDraggableHandle,
      width,
      onAddPanel,
      onRemovePanel,
      onEditPanel,
      onDuplicatePanel,
      onSectionChange,
      onSectionLayoutChange,
      canEdit
    } = this.props;

    return panels.map((panel) => {
      const layout = panel.get('layout').lg;

      const approxWidth =
        width < gridLayoutDefaults.breakpoints.lg ? width : (width / gridLayoutDefaults.cols.lg) * layout.w;

      return (
        <BoardPanelView
          board={board}
          key={panel.id}
          panel={panel}
          height={panel.itemHeight}
          approxWidth={approxWidth}
          onEditPanel={onEditPanel}
          onDuplicatePanel={onDuplicatePanel}
          onAddPanel={onAddPanel}
          onRemovePanel={onRemovePanel}
          dragHeaderCls={itemDraggableHandle}
          onSectionLayoutChange={onSectionLayoutChange}
          onSectionChange={onSectionChange}
          canCustomize={canEdit}
          interactive={canEdit}
        />
      );
    });
  }

  render() {
    const {
      board,
      layout,
      canEdit,
      itemDraggableHandle,
      width,
      onResizeStart,
      onResize,
      onResizeStop,
      onDragStart,
      onDrag,
      onDragStop
    } = this.props;
    const { breakpoint } = board;

    return (
      <Responsive
        className="board-grid-layout"
        {...gridLayoutDefaults}
        breakpoints={{ sm: 0, lg: 1, [breakpoint]: 2 }} // workaround RGL breakpoint bug
        breakpoint={breakpoint}
        isDraggable={canEdit}
        isResizable={canEdit}
        resizeHandles={['se']}
        // the entire Widget title bar
        draggableHandle={`.${itemDraggableHandle}`}
        draggableCancel=".no-drag"
        layouts={layout}
        onLayoutChange={this.handleLayoutChange}
        onResizeStart={onResizeStart}
        onResize={onResize}
        onResizeStop={onResizeStop}
        onDragStart={onDragStart}
        onDrag={onDrag}
        onDragStop={onDragStop}
        width={width}
      >
        {this.renderPanels()}
      </Responsive>
    );
  }
}

export default BoardGridLayout;
